import React from "react";
import { ProductResults } from "@tkww/ads-content-component-fashion";
import { ModalQuiz } from "@tkww/ads-content-component-fashion-stylematch";
import Favorite from "../Favorite";
import GalleryInstagramSection from "../GalleryInstagramSection";
import GalleryLocalFinder from "../GalleryLocalFinder";
import ArticleCarousel from "../ArticleCarousel";
import TKRetakeBanner from "../RetakeBanner";

const ResultsComponent = ({ products, friendlyFindsProducts, layoutProps, topPickCollection, modalEntryPoint, modalCtaUrl, facadeProduct, quizUrl }) => {

  const shouldItRender = (props) => {
    try {
      const quizCompleted = JSON.parse(localStorage.getItem("fashion_stylematch_quiz_completed"));
      const modalDismissed = JSON.parse(localStorage.getItem("fashion_stylematch_modal_dismissed"));
      const quizPending = JSON.parse(localStorage.getItem("fashion_stylematch_quiz_pending"));

      if (quizCompleted || quizPending || modalDismissed) {
        return false;
      }

      if (facadeProduct !== "WeddingDress") {
        return false;
      }

      if (layoutProps.isDesignerPage) {
        return false;
      }

      if (!props.isOpen) {
        return false;
      }
      return true;
    } catch (e) {
      console.error("Error in shouldItRender:", e);
      return false;
    }
  };

  const handleClose = (props) => {
    localStorage.setItem("fashion_stylematch_modal_dismissed", true);
    window.dispatchEvent(new Event("localStorageChanged"));
    if (props && props.closeModal) {
      props.closeModal();
    }
  };

  const shouldRenderRetakeBanner = !layoutProps.isDesignerPage;
  const retakeBanner = shouldRenderRetakeBanner
    ? <TKRetakeBanner containerClass="retake-banner-container--grid" quizUrl={quizUrl} facadeProduct={facadeProduct} />
    : null;

  return (
    <ProductResults
      products={products}
      friendlyFindsProducts={friendlyFindsProducts}
      layoutProps={layoutProps}
      modalComponent={(props) =>
        shouldItRender(props) ? (
          <ModalQuiz
            {...props}
            closeModal={() => handleClose(props)}
          />
        ) : null
      }
      modalEntryPoint={modalEntryPoint}
      modalCtaUrl={modalCtaUrl}
      topPickCollection={topPickCollection}
      favoriteComponent={(props) => (
        <Favorite
          {...props}
          classes="updated-favorite-button"
          containerClasses="updated-favorite-container"
        />
      )}
      instagramGalleryComponent={(props) => (
        <GalleryInstagramSection {...props} />
      )}
      localVendorsComponent={(props) => <GalleryLocalFinder {...props} />}
      retakeBannerComponent={retakeBanner}
      articlesComponent={(props) =>
        layoutProps.articlesComponentProps.articleCardsInfos.length > 0 ? (
          <ArticleCarousel {...props} />
        ) : null
      }
      retakeBannerIndexDesktop={products.length < 23 ? (products.length - 1) : 22}
      retakeBannerIndexMobile={products.length < 20 ? (products.length - 1) : 15}
    />
  );
};

export default ResultsComponent;
